import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import EmojiPicker from 'emoji-picker-react';
import { $getSelection, $isRangeSelection, TextNode } from 'lexical';
import { useState } from 'react';
import ReactTooltip from 'react-tooltip';



/**
 * Emoji Plugin for Lexical Editor
 * @param {*} pickerDirection - Placement of the emoji picker (default is "bottom") 
 * @returns 
 */
const EmojiPlugin = ({pickerDirection="bottom"}) => {
    const [editor] = useLexicalComposerContext(); 
    const [showPicker, setShowPicker] = useState(false); 

    const togglePicker = () => {
        setShowPicker(!showPicker); 
    }; 

    const handleEmojiSelect = (e, emojiData) => {
        const emoji = emojiData.emoji; 
        editor.update(() => {
            const selection = $getSelection(); 
            if($isRangeSelection(selection)) {
                selection.insertNodes([
                    new TextNode(emoji)
                ]);
            }
        }); 
    }
    let pickerStyle = {

    }
    if(pickerDirection === "bottom") {
        pickerStyle = {
            position: 'absolute', 
            right: '0', 
            top: '2em',
            zIndex: '10'
        }
    }
    else if(pickerDirection === "top") {
        pickerStyle = {
            position: 'absolute', 
            right: '0', 
            bottom: '2em',
            zIndex: '10'
        }
    }

    return(
        <div style={{position: 'relative'}}>
            <p
                onClick={togglePicker}
                className="emoji-picker-toggle"
                data-tip
                data-for="emoji-picker-tip"
            >
            😃
            </p>
            <ReactTooltip id="emoji-picker-tip" place="top" effect="solid">
            Add an emoji
            </ReactTooltip>
            {
                showPicker && (
                    <div style={pickerStyle}>
                        <EmojiPicker
                            onEmojiClick={handleEmojiSelect}
                            disableSearchBar={true}
                            disableSkinTonePicker={true}
                        />
                    </div>
                )
            }
        </div>
    )
}

export default EmojiPlugin; 